import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Catering = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my catering business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps catering businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for catering businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most catering businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my catering business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like catering. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Catering - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Catering CRM", url: "/industries/catering" }
  ];

  const industryData = {
    name: 'Catering Service',
    title: 'Book More Events & Never Miss a Last-Minute Inquiry',
    subtitle: 'Capture event inquiries 24/7, automate menu selections, and manage bookings without the back-and-forth',
    icon: '🍽️',
    challenges: [
      'Missing inquiries during events',
      'Too much back-and-forth on menu planning',
      'Hard to manage multiple event bookings',
      'Last-minute changes cause chaos',
      'Difficult to get deposits and final payments'
    ],
    solutions: [
      '24/7 inquiry capture with instant quotes',
      'Interactive menu selection system',
      'Centralized event calendar and management',
      'Automated event timeline and reminders',
      'Payment automation and tracking'
    ],
    features: [
      'Event CRM with full details',
      'Interactive menu builder',
      'Automated quote generation',
      'Event timeline automation',
      'Payment and deposit tracking',
      'Staff scheduling integration',
      'Review requests after events',
      'Corporate client management'
    ],
    results: [
      'Book 50% more events',
      '70% faster quote turnaround',
      '90% reduction in back-and-forth',
      '£7.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Catering UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for catering businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for catering UK, catering business software, catering customer management, catering lead generation UK"
        url="/industries/catering"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Catering;